import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";

 export class QuoteNoteBus extends BaseBus
 { 
     constructor(busObj: BaseBus = null) {
         super(busObj);
         if (CommonFunctions.hasValue(this.insertDt)) {
             this.insertDt = new Date(this.insertDt);
         }
         if (CommonFunctions.hasValue(this.updateDt)) {
             this.updateDt = new Date(this.updateDt);
         }
     }

     CID(): any {
         return this.quoteNoteId;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }
     setParentId(id: any) {
         this.quoteId = id;
     }
     setBeforeSave() {
         this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
         this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
     }
    quoteNoteId: string;
    quoteId: string;
    quoteNotePersonId: string;
    quoteNotes: string;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
    updateUserId: string;
    isPrintable: boolean;
    sortOrder: number;
}
